import React, { useState } from "react";
import {
  Container,
  InputLabel,
  Box,
  FormControl,
  Select,
  MenuItem,
  AlertTitle,
  Alert,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import CssBaseline from "@mui/material/CssBaseline";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fileReportDownload } from "../../../utils/fileReportDownload";
import { dateToFormat } from "../../../utils/dateParsing";
import es from "date-fns/locale/es";

const REPORTS_TYPE = [
  { name: 'Atenciones', url: '/aphbogota_xls_export/attentions', file: 'atenciones' },
  { name: 'Inspección preoperacional', url: '/aphbogota_xls_export/preoperational_inspection', file: 'inspeccion-preoperacional' },
  { name: 'Historia clínica TAM', url: '/aphbogota_xls_export/clinical_histories', file: 'historia-clinica-tam' },
  { name: 'Registro asistencial TAB', url: '/aphbogota_xls_export/attendance_record', file: 'registro-asistencial-tab' },
  { name: 'Inventario equipos biomédicos', url: '/aphbogota_xls_export/biomedical_equipment_inventory', file: 'equipos-biomedicos' },
  { name: 'Furtran (excel)', url: '/aphbogota_xls_export/furtran', file: 'furtran' },
  { name: 'Furtran (txt)', url: '/aphbogota_xls_export/furtran_txt', file: 'furtran_txt', extention:'txt' },
  { name: 'Limpieza y desinfección PDF', url: '/aph_bogota_sur_pdf/export_cleaning_disinfection', file: 'limpizas-desinfeccion', showAmbulanceField: true, isPDF:true },
  { name: 'Humedad relativa PDF', url: '/aph_bogota_sur_pdf/export_relative_humidity', file: 'humedad-relativa', showAmbulanceField: true, isPDF:true },
  { name: 'Temperatura ambiente PDF', url: '/aph_bogota_sur_pdf/export_temperature', file: 'temperatura-ambiente', showAmbulanceField: true, isPDF:true },
  { name: 'Reporte de tiempos', url: '/aphbogota_xls_export/time_report', file: 'reporte-tiempos' },
  { name: 'Total despacho por ambulancia', url: '/aphbogota_xls_export/dispatch_ambulance', file: 'total-despachos-ambulancia' },
  { name: 'Acumulado novedades biomédicas', url: '/aphbogota_xls_export/accumulated_biomedical_news', file: 'acumulado-novedades-biomedicas' },
  { name: 'Acumulado novedades mecánicas', url: '/aphbogota_xls_export/accumulated_mechanical_news', file: 'acumulado-novedades-mecanicas' },
];

const AMBULANCE_LIST = [
  {ambulance:'JQV234', mobileCode:'6926'},
  {ambulance:'JQV235', mobileCode:'6968'},
  {ambulance:'JQV254', mobileCode:'7026'},
  {ambulance:'LIS771', mobileCode:'7033'},
  {ambulance:'JQV201', mobileCode:'7036'},
  {ambulance:'LIS772', mobileCode:'7049'},
  {ambulance:'JQV288', mobileCode:'7063'},
  {ambulance:'JQV282', mobileCode:'7064'},
  {ambulance:'RZP006', mobileCode:'6399'},
  {ambulance:'RZP007', mobileCode:'6403'},
  {ambulance:'RZP005', mobileCode:'6405'},
  {ambulance:'RZP003', mobileCode:'6406'},
  {ambulance:'RZK983', mobileCode:'6437'},
  {ambulance:'RZP436', mobileCode:'6438'},
  {ambulance:'OJX930', mobileCode:'5161'},
  {ambulance:'RZK973', mobileCode:'6557'},
  {ambulance:'RZK976', mobileCode:'6558'},
  {ambulance:'OCK259', mobileCode:'5179'},
  {ambulance:'RZK974', mobileCode:'6561'},
  {ambulance:'RZK981', mobileCode:'6562'},
  {ambulance:'RZV843', mobileCode:'6564'},
  {ambulance:'RZV130', mobileCode:'6560'},
  {ambulance:'RZF372', mobileCode:'6404'},
  {ambulance:'RZP432', mobileCode:'6408'},
  {ambulance:'RZF361', mobileCode:'6442'},
  {ambulance:'RZK969', mobileCode:'6559'},
  {ambulance:'RZV842', mobileCode:'6443'},
];


export const APHBogotaReport = () => {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [ambulanceSelected, setAmbulanceSelected] = useState({});
  const [filterType, setFilterType] = useState(REPORTS_TYPE[0]);
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});

  registerLocale("es", es);

  const handleSubmit = (event) => {
    event.preventDefault();
    requestReport();
  };

  const requestReport = async () => {
    try {
      const params = {
        fromDate: dateToFormat(fromDate, 'YYYY/MM/DD HH:mm'),
        untilDate: dateToFormat(toDate, 'YYYY/MM/DD HH:mm'),
        ambulance: ambulanceSelected.ambulance
      }
      setShowAlert(false);
      setLoading(true);
      const extention = filterType.isPDF?'pdf':'xlsx'
      await fileReportDownload(filterType.url, params, `${filterType.file}.${filterType.extention || extention}`,filterType.isPDF);
      setLoading(false);
    } catch (error) {
      console.log("error -> ", error);
      if (error.response.status === 406) { //range bad
        setAlertInfo({
          title: "Error",
          message: "Rango de fecha excedido",
          action: "Cambia el rango de fechas",
        });
        setShowAlert(true);
      } else if (error.response.status === 400) { // rango no válido
        setAlertInfo({
          title: "Error",
          message: "El rango de fecha no es válido",
          action: "Valida que el rango sea correcto",
        });
        setShowAlert(true);
      } else if (error.response.status === 0) {
        setAlertInfo({
          title: "Timeout",
          message: "Ocurrio un error procesando",
          action: "Intenta reduciendo el rango de fechas",
        });
        setShowAlert(true);
      } else {
        setAlertInfo({
          title: "Error del servidor",
          message: "Ocurrio un error procesando",
          action: "Intenta reduciendo el rango de fechas",
        });
        setShowAlert(true);
      }
      setLoading(false);
    }
  };

  const handleChangeSelect = (event) => {
    event.preventDefault();
    setFilterType(event.target.value);
  };

  const handleChangeAmbulanceSelect = (event) => {
    event.preventDefault();
    setAmbulanceSelected(event.target.value)
  };

  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          {showAlert && (
            <Alert onClose={() => setShowAlert(false) } severity="error">
              <AlertTitle>{alertInfo?.title}</AlertTitle>
              {alertInfo?.message} — <strong>{alertInfo?.action}</strong>
            </Alert>
          )}

          <InputLabel>Desde</InputLabel>
          <div style={{ display: "flex", marginBottom: 10 }}>
            <DatePicker
              dateFormat="yyyy/MM/dd HH:mm"
              selected={fromDate}
              onChange={setFromDate}
              showTimeSelect
              name="fromDate"
              locale="es"
              className="react-datetimepicker-custom"
            />
          </div>

          <InputLabel>Hasta</InputLabel>
          <div style={{ display: "flex" }}>
            <DatePicker
              dateFormat="yyyy/MM/dd HH:mm"
              selected={toDate}
              onChange={setToDate}
              showTimeSelect
              name="toDate"
              locale="es"
              className="react-datetimepicker-custom"
            />
          </div>

          <br />
          <FormControl fullWidth>
            <InputLabel id="filtertype-select-label">Filtrar Por</InputLabel>
            <Select
              labelId="filtertype-select-label"
              id="filtertype-select"
              value={filterType}
              label="filterType"
              onChange={handleChangeSelect}
              name="filtertype-select"
            >
              {
                REPORTS_TYPE.map((item, key) => <MenuItem value={item}>{item.name}</MenuItem> )
              }
            </Select>
          </FormControl>

          {
            filterType.showAmbulanceField ?
            <>
              <br/>
              <br/>
              <FormControl fullWidth>
                <InputLabel id="filtertype-ambulance-label">Seleccione la placa</InputLabel>
                <Select
                  labelId="filtertype-ambulance-label"
                  id="filtertype-ambulance"
                  value={ambulanceSelected}
                  label="Seleccione la placa"
                  onChange={handleChangeAmbulanceSelect}
                  name="filtertype-ambulance"
                >
                  {
                    AMBULANCE_LIST.map((item, key) => 
                    <MenuItem key={key+item.ambulance} value={item}>
                      {item.ambulance}
                    </MenuItem>)
                  }
                </Select>
              </FormControl>
            </>
              : null
          }

          <LoadingButton
            type="submit"
            fullWidth
            loading={loading}
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Generar Reporte
          </LoadingButton>
        </Box>
      </Box>
    </Container>
  );
};
